type Props = {
    clickHandler: () => void;
    text: string;
};

function LinkCTA({ clickHandler, text }: Props) {
    return (
        <>
            <button onClick={clickHandler}>{text}</button>
            <style jsx>{`
                button {
                    color: #1b73e8;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 20px;
                    padding: 10px 0 0 0;
                    text-align: center;
                    background: none;
                    border: none;
                    outline: none;
                    width: 100%;
                }
            `}</style>
        </>
    );
}

export default LinkCTA;
